/*
  Nekonecny auto-scroll carousel pro sekci "KF Auto carousel".

  Vedouci (prvni) karta je siroka na dva sloupce, ostatni na vysku.
  Pri posunu se vedouci karta zmensi a odjede, nasledujici naroste.

  Flickity z vendor.js se tu pouzit neda - pozice bunek prepocitava skokove,
  takze by plynula zmena sirky rozhodila layout. Pohyb proto ridime sami:
  posuneme drahu presne o sirku odchazejici karty a pak ji prendame na konec.
  Sipky zustavaji komponenta sablony (slider:previous / slider:next).
*/
(function () {
  if (customElements.get('auto-carousel')) return;

  class AutoCarousel extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;
      this.track = this.querySelector('.kf-track');
      if (!this.track) return;

      this.animating = false;
      this.fillTrack();
      this.setLead();
      this.measure();

      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);

      this.addEventListener('slider:previous', this.onPrev);
      this.addEventListener('slider:next', this.onNext);
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('pointermove', this.onPointerMove);
      this.addEventListener('pointerup', this.onPointerUp);
      this.addEventListener('pointercancel', this.onPointerUp);
      // po tazeni nesmi prokliknout odkaz na karte
      this.addEventListener('click', this.onClickCapture, true);
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.play());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.play());

      this.play();

      if (window.Shopify && Shopify.designMode) {
        this.stop();
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.kf-card');
          if (card) this.bringToFront(card);
        });
      }
    }

    disconnectedCallback() {
      this.stop();
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this._booted = false;
    }

    /* Sirky pocitame v px a davame je do inline promennych.
       Prechod mezi dvema calc() s procenty se v prohlizeci zasekne
       a nikdy nedointerpoluje - mezi dvema px hodnotami funguje spravne. */
    measure() {
      const styles = getComputedStyle(this);
      const visible = parseFloat(styles.getPropertyValue('--kf-visible')) || 4;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      // clientWidth zahrnuje i vlastni odsazeni (full bleed na mobilu),
      // sirka karty se musi pocitat z obsahove sirky
      const available = this.clientWidth
        - parseFloat(styles.paddingLeft || 0)
        - parseFloat(styles.paddingRight || 0);
      if (!available || !visible) return;

      const unit = (available - (visible - 1) * gap) / visible;
      this.unitPx = unit;
      this.gapPx = gap;

      const wasAnimating = this.track.style.transition;
      this.setTransition(false);
      this.track.classList.add('is-measuring');
      this.style.setProperty('--kf-unit-px', unit + 'px');
      this.style.setProperty('--kf-wide-px', unit * 2 + gap + 'px');
      void this.track.offsetWidth;
      this.track.classList.remove('is-measuring');
      this.track.style.transition = wasAnimating;
    }

    get cards() {
      return Array.from(this.track.children);
    }

    get morphMs() {
      return parseInt(this.getAttribute('morph-speed')) || 600;
    }

    get reduceMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    get autoplayMs() {
      if (!this.hasAttribute('autoplay') || this.reduceMotion) return 0;
      return (parseFloat(this.getAttribute('autoplay-speed')) || 4) * 1000;
    }

    /* Vedouci karta zabira dva sloupce, takze na zaplneni viewportu je potreba
       o jednu kartu vic. Pri malo blocich radu doplnime kopiemi. */
    fillTrack() {
      const visible = parseFloat(getComputedStyle(this).getPropertyValue('--kf-visible')) || 4;
      const needed = Math.ceil(visible) + 1;
      const originals = this.cards;
      if (originals.length === 0) return;

      let guard = 0;
      while (this.cards.length < needed && guard < 12) {
        originals.forEach((card) => {
          const clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.kfClone = 'true';
          this.track.appendChild(clone);
        });
        guard += 1;
      }
    }

    setLead() {
      this.cards.forEach((card, index) => card.classList.toggle('is-lead', index === 0));
    }

    // Sirka bezne (nevedouci) karty + mezera - o tolik se draha posouva
    stepSize() {
      if (!this.unitPx) this.measure();
      return (this.unitPx || 0) + (this.gapPx || 0);
    }

    setTransition(on) {
      this.track.style.transition = on ? `transform ${this.morphMs}ms cubic-bezier(0.65, 0, 0.35, 1)` : 'none';
    }

    afterMove(callback) {
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        this.track.removeEventListener('transitionend', onEnd);
        callback();
      };
      const onEnd = (event) => {
        if (event.target === this.track && event.propertyName === 'transform') finish();
      };
      this.track.addEventListener('transitionend', onEnd);
      setTimeout(finish, this.morphMs + 200); // pojistka, kdyz transitionend nedorazi
    }

    onNext = (event) => {
      if (event) event.stopPropagation();
      this.next();
    };

    onPrev = (event) => {
      if (event) event.stopPropagation();
      this.previous();
    };

    next() {
      if (this.animating || this.cards.length < 2) return;
      this.animating = true;
      this.stepPx = this.stepSize();
      this.commitNext();
    }

    previous() {
      if (this.animating || this.cards.length < 2) return;
      this.animating = true;
      this.stepPx = this.stepSize();
      this.preparePrev();
      void this.track.offsetWidth; // potvrdi vychozi stav, aby se prechod rozjel
      this.commitPrev();
    }

    /* Prichozi kartu predradime a drahu posuneme o jeji sirku,
       takze se vizualne jeste nic nezmeni. */
    preparePrev() {
      this.setTransition(false);
      this.track.insertBefore(this.track.lastElementChild, this.track.firstElementChild);
      this.track.style.transform = `translateX(${-this.stepPx}px)`;
    }

    undoPrepare() {
      this.setTransition(false);
      this.track.appendChild(this.track.firstElementChild);
      this.track.style.transform = 'translateX(0)';
      void this.track.offsetWidth;
    }

    commitNext() {
      const leaving = this.track.firstElementChild;
      leaving.classList.remove('is-lead');
      this.track.children[1].classList.add('is-lead');

      this.setTransition(true);
      this.track.style.transform = `translateX(${-this.stepPx}px)`;

      this.afterMove(() => {
        this.setTransition(false);
        this.track.appendChild(leaving);
        this.track.style.transform = 'translateX(0)';
        void this.track.offsetWidth;
        this.animating = false;
      });
    }

    commitPrev() {
      const incoming = this.track.firstElementChild;
      this.track.children[1].classList.remove('is-lead');
      incoming.classList.add('is-lead');

      this.setTransition(true);
      this.track.style.transform = 'translateX(0)';

      this.afterMove(() => {
        this.animating = false;
      });
    }

    /* --- Tazeni prstem / mysi --- */

    onPointerDown = (event) => {
      if (this.animating || this.cards.length < 2) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.dragging = true;
      this.axis = null;
      this.prepared = false;
      this.dragBase = 0;
      this.dragX = event.clientX;
      this.dragY = event.clientY;
      this.moved = false;
      this.stepPx = this.stepSize();
      this.stop();
    };

    onPointerMove = (event) => {
      if (!this.dragging) return;
      const dx = event.clientX - this.dragX;
      const dy = event.clientY - this.dragY;

      // dokud nevime smer, nechame gesto na pokoji - svisle patri strance
      if (!this.axis) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        this.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (this.axis === 'x' && this.setPointerCapture) {
          try { this.setPointerCapture(event.pointerId); } catch (e) {}
        }
      }
      if (this.axis !== 'x') return;

      this.moved = true;

      if (dx > 0 && !this.prepared) {
        this.preparePrev();
        this.prepared = true;
        this.dragBase = -this.stepPx;
      }

      this.setTransition(false);
      this.track.style.transform = `translateX(${this.dragBase + dx}px)`;
    };

    onPointerUp = (event) => {
      if (!this.dragging) return;
      const dx = event.clientX - this.dragX;
      const horizontal = this.axis === 'x';
      this.dragging = false;
      this.axis = null;

      if (!horizontal) {
        this.play();
        return;
      }

      const threshold = Math.min(80, this.stepPx * 0.25);
      this.animating = true;

      if (this.prepared) {
        if (dx >= threshold) {
          this.commitPrev();
        } else {
          this.setTransition(true);
          this.track.style.transform = `translateX(${-this.stepPx}px)`;
          this.afterMove(() => {
            this.undoPrepare();
            this.animating = false;
          });
        }
      } else if (dx <= -threshold) {
        this.commitNext();
      } else {
        this.setTransition(true);
        this.track.style.transform = 'translateX(0)';
        this.afterMove(() => {
          this.animating = false;
        });
      }

      this.prepared = false;
      this.play();
    };

    onClickCapture = (event) => {
      if (!this.moved) return;
      this.moved = false;
      event.preventDefault();
      event.stopPropagation();
    };

    bringToFront(card) {
      let guard = 0;
      while (this.cards[0] !== card && guard < this.cards.length) {
        this.track.appendChild(this.track.firstElementChild);
        guard += 1;
      }
      this.setLead();
    }

    play() {
      this.stop();
      const ms = this.autoplayMs;
      if (ms > 0) this.timer = setInterval(() => this.next(), ms);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('auto-carousel', AutoCarousel);
})();
